import { render, staticRenderFns } from "./redirection_detail.vue?vue&type=template&id=56069487&"
import script from "./redirection_detail.vue?vue&type=script&lang=js&"
export * from "./redirection_detail.vue?vue&type=script&lang=js&"
import style0 from "./redirection_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports